import global from '../patterns/global-variables';
import $ from 'jquery';
window.jQuery = $;
import utils from '../patterns/utils';
import PL_utils from '../patterns/pl-utils';

export default () => {
    const token = utils.getParam('token');
    const verified = document.querySelector('.email-verified');
    const failed = document.querySelector('.email-failed');

    if (global.IS_ED_MODE && utils.getParam('state') == 'verified') {
        PL_utils.removeClass('hidden', verified);
    } else if (global.IS_ED_MODE && utils.getParam('state') == 'failed') {
        PL_utils.removeClass('hidden', failed);
    } else if (!token) {
        PL_utils.removeClass('hidden', failed);
    } else {
        PL_utils.removeClass("hidden", document.querySelector("#verify-email-pending"));
        $.ajax(global.API_ENDPOINT() + '/user/lookup-token_v1', {
            data: JSON.stringify({
                'anonymousToken': utils.getAnonymousToken(),
                'token': token
            }),
            dataType: 'json',
            method: 'POST',
            xhrFields: {
                withCredentials: true,
            }
        })
        .done(function (resp) {
            PL_utils.addClass("hidden", document.querySelector("#verify-email-pending"));
            if (!resp.success) {
                PL_utils.removeClass('hidden', failed);
            } else {
                PL_utils.removeClass('hidden', verified);
            }
        })
        .fail(function (err) {
            console.error(JSON.stringify(err));
            PL_utils.addClass("hidden", document.querySelector("#verify-email-pending"));
            PL_utils.removeClass('hidden', failed);
        })
    }

}

